import { TextStyle, View, ViewStyle } from "react-native"

import { TMessage } from "types/transcript"

import { Text } from "src/components/Ignite/Text"
import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"

export const SystemMessage = ({ item }: { item: TMessage }) => {
  const { themed } = useAppTheme()
  return (
    <View key={`${item.id}`} style={$systemMessage}>
      <View style={$horizontalBar} />
      <Text style={themed($messageText)}>{item.text}</Text>
      <View style={$horizontalBar} />
    </View>
  )
}

const $systemMessage: ViewStyle = {
  marginHorizontal: 5,
  alignItems: "center",
}

const $horizontalBar: ViewStyle = {
  borderBottomWidth: 1,
  borderBottomColor: "#333333",
  marginVertical: 2,
  width: "40%",
}

const $messageText: ThemedStyle<TextStyle> = ({ colors, typography }) => ({
  fontSize: 12,
  fontFamily: typography.primary.light,
  color: colors.white,
  textAlign: "center",
  paddingHorizontal: 30,
})
